import { ensureGARegistrationReadiness, getRegistrationRequestHeaders } from '@/lib/utm/registration-readiness';

export { ensureGARegistrationReadiness } from '@/lib/utm/registration-readiness';

/** 同步读取有效权限与已拿到的 GA 标识；不等 GTM、地区请求或额外用户请求。 */
export function getHomeRequestHeaders(): Record<string, string> {
    return getRegistrationRequestHeaders();
}

/** 产品区首请求前等一次 GA readiness 再生成请求头；之后的请求直接复用结果。 */
export async function getProductRequestHeaders(): Promise<Record<string, string>> {
    await ensureGARegistrationReadiness();
    return getRegistrationRequestHeaders();
}

/**
 * 需要透传到下一页的埋点 / 归因参数键。
 * 与 `@enter/utm` 的 UTM_KEYS 保持一致，并额外保留 link_id 这类 pass-through 归因外键。
 */
export const UTM_LINK_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'link_id',
] as const;

/**
 * 从当前页面的查询参数中挑出埋点 / UTM 字段，拼接到目标相对路径后面。
 *
 * @param path 站内相对路径（不含 locale 前缀），如 `/contact-sales`
 * @param currentSearch 当前页面查询串（可来自 next/navigation 的 useSearchParams().toString()
 *                      或 window.location.search）。允许带或不带前导 `?`。
 * @returns 带上被透传埋点参数的相对路径；无可透传参数时原样返回 path。
 */
export function appendTrackingParams(path: string, currentSearch?: string | null): string {
    if (!currentSearch) return path;

    const normalized = currentSearch.startsWith('?') ? currentSearch.slice(1) : currentSearch;
    if (!normalized) return path;

    const source = new URLSearchParams(normalized);
    const forwarded = new URLSearchParams();

    for (const key of UTM_LINK_KEYS) {
        const value = source.get(key);
        if (value) forwarded.set(key, value);
    }

    const query = forwarded.toString();
    if (!query) return path;

    return path.includes('?') ? `${path}&${query}` : `${path}?${query}`;
}
